'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useRouter } from 'next/navigation';
import VisualStory from './VisualStory';
interface VisualStoryWrapperProps {
  story: any;
  sliderAdCode?: string | null;
}
export default function VisualStoryWrapper(t0) {
  const $ = _c(9);
  const {
    story,
    sliderAdCode
  } = t0;
  const router = useRouter();
  const [mounted, setMounted] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setMounted(true);
      sessionStorage.removeItem("navigationIntent");
      sessionStorage.removeItem("pendingStoryTemplate");
      document.body.style.overflow = "hidden";
      document.documentElement.style.overflow = "hidden";
      return _temp;
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== router) {
    t3 = () => {
      router.back();
    };
    $[2] = router;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleClose = t3;
  if (!mounted) {
    let t4;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="fixed inset-0 z-[9999] overflow-hidden bg-black flex items-center justify-center"><div className="w-10 h-10 border-2 border-white/20 border-t-white rounded-full animate-spin" /></div>;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    return t4;
  }
  let t4;
  if ($[5] !== handleClose || $[6] !== sliderAdCode || $[7] !== story) {
    t4 = createPortal(<VisualStory story={story} onClose={handleClose} sliderAdCode={sliderAdCode} />, document.body);
    $[5] = handleClose;
    $[6] = sliderAdCode;
    $[7] = story;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}
function _temp() {
  document.body.style.overflow = "";
  document.documentElement.style.overflow = "";
}